import React from 'react';
import { AuthContext } from '../contexts/auth-context';
import { AWS_GROUP } from '../types';
import { usePermissions } from './use-permissions';

/**
 * The agent whose map inventory and cart the Lead Map and cart drawer work
 * with, and whether the user may change that cart.
 *
 * - AgtNo follows the app-wide rule: the impersonated agent, else the agent
 *   a staff account works for (myStaffForAgt), else the signed-in username.
 *   Admins who aren't impersonating get their username, which isn't an agent
 *   number, so the agent-scoped queries stay off (isAgt guards).
 * - readOnly: anyone impersonating without LDS_GlobalAdmin (an agent viewing
 *   a downline, an admin with only the impersonate permission) can see the
 *   agent's cart but not change or check it out. Only Leads admins manage
 *   another agent's cart.
 */
export function useCartAgent() {
  // Context
  const { state } = React.useContext(AuthContext);
  // Hooks
  const { hasGroup } = usePermissions();

  const isLeadsAdmin = hasGroup(AWS_GROUP.LDS_GlobalAdmin);
  const isImpersonating = state.impersonatedAgent !== null;
  const staffAgtNo: string | undefined = state.session
    ?.getAccessToken()
    .decodePayload()['myStaffForAgt'];

  const AgtNo: string | null =
    state.impersonatedAgent?.AgtNo ||
    staffAgtNo ||
    state.user?.getUsername() ||
    null;

  return {
    AgtNo,
    isLeadsAdmin,
    isImpersonating,
    readOnly: isImpersonating && !isLeadsAdmin,
  };
}
